export const NOT_PROVIDED = "Not Provided";
export const IMAGE_WIDTH = 306;
